<div class="filter-selector-wrapper" @filterSelectorFadeDown>

  <!-- main layers button -->
  <button
    (click)="toggleVisibility()"
    class="layers__button noselect mat-elevation-z2"
    [ngStyle]="baseMapTypeBackground(BaseMapType.WINTER)"
  >
    <mat-icon>layers</mat-icon>
    <span>Layers</span>
  </button>


  <!-- layers list -->
  @if (filterOpen) {
    <div class="layers__box mat-elevation-z2"
         [matTooltip]="isOverflowing ? 'Scroll to view more' : ''"
         matTooltipPosition="right"
         #horizontallyScrollableBox>

      <div class="layers__buttons">

        @for (baseMap of baseMaps; track $index) {
          <div class="map__filter__wrapper">
            <div
              [ngClass]="{ selected: baseMapLayerType === baseMap }"
              class="map__filter__square noselect"
              [ngStyle]="baseMapTypeBackground(baseMap)"
              (click)="switchBaseMap(baseMap)"
            ></div>
            <div class="map__filter__text">
              {{ baseMap === BaseMapType.DARK ? 'Night' : baseMap }}
            </div>
          </div>
        }

        @for (layer of this.customBaseMapLayers; track layer) {
          <div class="map__filter__wrapper">
            <div
              [ngClass]="{ selected: baseMapLayerType === BaseMapType.CUSTOM && customBaseMapLayerId === layer.name }"
              class="map__filter__square noselect no__background"
              (click)="switchToCustomBaseMap(layer)"
            >
              <mat-icon>layers</mat-icon>
            </div>
            <div class="map__filter__text">
              {{ layer.name }}
            </div>
          </div>
        }
      </div>

      @if (configuration) {
        <div class="layers__buttons">
          @if (hasFeatureFlag(FeatureFlagEnum.Weather)) {
            <div class="map__filter__wrapper">
              <div [ngClass]="{ selected: showRadar }"
                   [ngStyle]="weatherLayerToggleBackground(WeatherLayerType.RADAR)"
                   class="map__filter__square noselect"
                   (click)="toggleRadar()"
              ></div>
              <div class="map__filter__text">
                Weather
              </div>
            </div>
          }

          <div class="map__filter__wrapper">
            <div [ngClass]="{ selected: showTraffic }"
                 [ngStyle]="weatherLayerToggleBackground(WeatherLayerType.TRAFFIC)"
                 class="map__filter__square noselect"
                 (click)="toggleTrafficLayer()"
            ></div>
            <div class="map__filter__text">
              Traffic
            </div>
          </div>
        </div>
      }

      <div class="layers__buttons no-border">
        @for (customLayer of customMapLayers; track $index) {
          <div class="map__filter__wrapper">
            <div class="map__filter__square noselect no__background"
                 [ngClass]="{ selected: customLayer.checked }"
                 (click)="toggleCustomMapLayer(customLayer, !customLayer.checked)"
            >
              <mat-icon>layers</mat-icon>
            </div>
            <div class="map__filter__text">
              {{ customLayer.name }}
            </div>
          </div>
        }

        <div class="add__button__wrapper">
          <button mat-icon-button
                  matTooltip="Manage Additional Layers"
                  (click)="openLayerVisibilitySettings()">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>

    </div>
  }

</div>
